import React, { useState } from 'react';
import '../scss/AddCashModal.scss';

function AddCashModal({ player, onClose, onSubmit }) {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || isNaN(amount) || amount <= 0) {
      setError('Please enter a valid amount');
      return;
    }

    // Get current date and time in MySQL DATETIME format (YYYY-MM-DD HH:mm:ss)
    const now = new Date();
    const dateTime = now.toISOString().slice(0, 19).replace('T', ' ');

    onSubmit({
      playerId: player.id,
      amount: parseFloat(amount),
      date: dateTime,  // Now includes time
      description: `CASH PAYMENT - ${player.name}`
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add Cash Payment</h3>
        <p>Adding payment for {player.name}</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Amount (£)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
            />
          </div>
          
          {error && <p className="error">{error}</p>}
          
          <div className="button-group">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Add Payment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCashModal;